module.exports = __webpack_public_path__ + "static/media/ゴンゴン.167d5176.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/store/ゴンゴン.png
// module id = 336
// module chunks = 10